<template>
    <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="enrollmentsFiltered"
        :fields="fields"
        name="reporteMatricula.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm12 md2>
              <span>Reportes Matrículas</span>
            </v-flex>
            <v-flex mr-3 xs4>
              <v-select
                :items="enrollments_to_select"
                v-model="filter_enrollment"
                label="Filtrar matrícula"
                item-text="description"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

         <v-data-table
            :headers="headers"
            :items="enrollmentsFiltered"
            :search="search"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.created_at }}</td>
                <td class="text-xs-center">{{ props.item.family_id }}</td>
                <td class="text-xs-center">{{ props.item.student_number }}</td>
                <td class="text-xs-center">{{ props.item.full_name }}</td>
                <td class="text-xs-center">{{ props.item.student_grade_enrollment }}</td>
                <td class="text-xs-center">{{ props.item.current_step }}</td>
                <td class="text-xs-center" v-if="validateIfErrorExist(props.item.factura_siesa) === true">{{ props.item.factura_siesa }}</td>
                <td class="text-xs-center" v-else-if="validateIfErrorExist(props.item.factura_siesa) === false">
                  <v-btn
                    block
                    color="error"
                    @click="showError(props.item.factura_siesa)"
                  >
                    Error
                  </v-btn>
                </td>
                <td class="text-xs-center" v-else-if="validateIfErrorExist(props.item.factura_siesa) == ''"></td>
                <td class="text-xs-center" v-if="validateIfErrorExist(props.item.pago_siesa) === true">{{ props.item.pago_siesa }}</td>
                <td class="text-xs-center" v-else-if="validateIfErrorExist(props.item.pago_siesa) === false">
                  <v-btn
                    block
                    color="error"
                    @click="showError(props.item.pago_siesa)"
                  >
                    Error
                  </v-btn>
                </td>
                <td class="text-xs-center" v-else-if="validateIfErrorExist(props.item.pago_siesa) == ''"></td>
                <td class="text-xs-center">{{ props.item.payment_type }}</td>
                <td class="text-xs-center">{{ props.item.cicle }}</td>
                <td class="text-xs-center">{{ props.item.platform_payment_total }}</td>
                <td class="text-xs-center">{{ props.item.traceability_code }}</td>
                <td>
                  <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="showEnrollmentDocuments(props.item.enrollment_id, props.item.student_id)"
                        slot="activator"
                      >
                        file_copy
                      </v-icon>
                    <span>Ver documentos</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="showEnrollmentPayments(props.item.enrollment_id, props.item.student_id)"
                      slot="activator"
                    >
                      monetization_on
                    </v-icon>
                    <span>Ver Pagos</span>
                  </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">Documento cargado</span>
            </v-card-title>

            <v-card-text>
                <object :data="path_file" width="460px" height="500px"></object>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="dialog = false">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogInfo" persistent max-width="900px" width="auto">
        <v-card>
            <v-card-title>
            <span class="headline">{{ infoTitle }}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout row>
                        <v-flex xs12>
                            <v-data-table
                                :headers="enrollmentInfoHeaders"
                                :items="infoItems"
                                v-show="documentsInfo"
                            >
                                <template  slot="items" slot-scope="props">
                                    <td class="text-xs-center">{{ props.item.document ? props.item.document.description : 'Libro Matrículas' }}</td>
                                    <td class="text-xs-center">{{ props.item.document ? props.item.document.document_type : '' }}</td>
                                    <td class="text-xs-center">{{ props.item.document ? props.item.document.description : '' }}</td>
                                    <td class="text-xs-center">{{ props.item.document ? props.item.document.ext : '' }}</td>
                                    <td class="text-xs-center">{{ props.item.required_next_step === '["ALL"]' ? 'Si' : props.item.required_next_step === null ? 'No' : 'Parcial' }}</td>
                                    <td class="text-xs-center">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            @click="showFile(props.item)"
                                        >
                                          remove_red_eye
                                        </v-icon>
                                        <a :href="path_file" download>
                                          <v-icon
                                            small
                                            class="mr-2"
                                            @click="showFile(props.item, false)"
                                          >
                                            cloud_download
                                          </v-icon>
                                        </a>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>

                    <v-layout row justify-center align-center>
                      <v-flex xs12 sm7 md5 lg4>
                        <v-card class="mb-3" v-show="!documentsInfo">
                          <v-toolbar color="primary" dark>

                            <v-toolbar-title>Pago {{ $t(`enrollments.payment_status.${payment_detail.payment_state}`) }}</v-toolbar-title>

                          </v-toolbar>

                          <v-list
                            subheader
                            dense
                          >
                            <v-subheader>Detalle de pago: {{ payment_detail.name }}</v-subheader>

                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Tipo de pago</v-list-tile-title>
                                <v-list-tile-sub-title>{{ payment_detail.payment_type }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Referencia</v-list-tile-title>
                                <v-list-tile-sub-title>{{ payment_detail.payment_id }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Autorización/CUS</v-list-tile-title>
                                <v-list-tile-sub-title>{{ payment_detail.traceability_code }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Fecha y hora</v-list-tile-title>
                                <v-list-tile-sub-title>{{ payment_detail.updated_at }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Total</v-list-tile-title>
                                <v-list-tile-sub-title>{{payment_detail.payment_currency}} {{ formatNumber(payment_detail.total) }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="dialogInfo = false">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogError" persistent max-width="900px" width="auto">
        <v-card>
            <v-card-title>
            <span class="headline">{{ infoTitle }}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                  <v-layout row>
                    <v-flex xs12>
                      {{ error_siesa }}
                    </v-flex>
                  </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="dialogError = false">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import JsonExcel from 'vue-json-excel'
import { mapGetters } from 'vuex'
export default {
  name: 'school-services-report-view',
  components: {
      'download-excel': JsonExcel,
  },
  data() {
    return {
      headers: [
        { text: 'Fecha y hora creación', align: 'center', value: 'created_at' },
        { text: 'Código familia', align: 'center', value: 'family_id' },
        { text: 'Código estudiante', align: 'center', value: 'student_number' },
        { text: 'Nombre estudiante', align: 'center', value: 'full_name' },
        { text: 'Grado estudiante', align: 'center', value: 'student_grade_enrollment' },
        { text: 'Paso actual', align: 'center', value: 'current_step' },
        { text: 'Factura siesa', align: 'center', value: 'factura_siesa' },
        { text: 'Pago siesa', align: 'center', value: 'pago_siesa' },
        { text: 'Tipo pago', align: 'center', value: 'payment_type' },
        { text: 'Ciclo', align: 'center', value: 'cicle' },
        { text: 'Total', align: 'center', value: 'platform_payment_total' },
        { text: 'Cus', align: 'center', value: 'traceability_code' },
        { text: 'Acciones', align: 'center', value: 'actions', sortable: false }
      ],
      loadingTable: false,
      dialog: false,
      dialogInfo: false,
      infoTitle: '',
      enrollmentInfoHeaders: [],
      infoItems: [],
      documentsInfo: true,
      path_file: '',
      payment_detail: {},
      enrollments: [],
      loading: false,
      search: '',
      fields: {
          'Fecha y hora creación': 'created_at',
          'Código familia': 'family_id',
          'Código estudiante': 'student_number',
          'Nombre estudiante': 'full_name',
          'Grado estudiante': 'student_grade_enrollment',
          'Paso actual': 'current_step',
          'Factura siesa': 'factura_siesa',
          'Pago siesa': 'pago_siesa',
          'Tipo pago': 'payment_type',
          'Ciclo': 'cicle',
          'Total': 'platform_payment_total',
          'Cus': 'traceability_code',
      },
      documentsHeaders: [
        { text: 'Documento', align: 'center', value: 'document' },
        { text: 'Tipo Doc', align: 'center', value: 'document_type' },
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Extensión', align: 'center', value: 'ext' },
        { text: 'Requerido paso 4', align: 'center', value: 'required_next_step' },
        { text: 'Acciones', align: 'center', value: 'required_next_step' }
      ],
      dialogError: false,
      error_siesa: '',
      url_base: window.config.vistaUrl,
      enrollments_to_select: [],
      filter_enrollment: '',
    }
  },
  computed: {
    ...mapGetters({
        enrollment_status: 'currentEnrollment',
    }),
    enrollmentsFiltered() {
      let enrollments_to_filter = this.enrollments
      if (this.filter_enrollment && this.filter_enrollment !== '') {
        enrollments_to_filter = this.enrollments.filter(e => e.enrollment_id == this.filter_enrollment)
      }
      return enrollments_to_filter
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    enrollment_status(newValue, oldValue) {
      this.infoItems = newValue.documents
      if(newValue.enrollment) {
        if(newValue.payment) {
          this.payment_detail = {
            name: newValue.enrollment.description,
            payment_type: newValue.payment.payment_type,
            payment_id: newValue.payment.payment_id,
            traceability_code: newValue.payment.traceability_code,
            updated_at: newValue.payment.updated_at,
            payment_currency: newValue.payment.payment_currency,
            payment_state: newValue.payment.payment_state,
            total: newValue.payment.service_payment_total || newValue.payment.platform_payment_total,
          }
        } else {
          this.payment_detail = {
            name: newValue.enrollment.description,
            payment_type: '',
            payment_id: '',
            traceability_code: '',
            updated_at: '',
            payment_currency: '',
            payment_state: '',
            total: '',
          }
        }
      } else {
        this.payment_detail = {
          name: '',
          payment_type: '',
          payment_id: '',
          traceability_code: '',
          updated_at: '',
          payment_currency: '',
          total: '',
        }
      }
    }
  },
  created() {
    this.getEnrollmentsByFamily()
  },
  methods: {
    async getEnrollmentsByFamily() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/enrollment/reports')
      this.enrollments = data.report;
      this.enrollments_to_select = data.enrollments
      this.loadingTable = false;
    },
    close() {
      this.dialog = false
    },
    async showEnrollmentDocuments(enrollment_id, student_id) {
        const payload = {
          enrollment_id: enrollment_id,
          student_id: student_id
        }
        await this.$store.dispatch('fetchEnrollmentStatus', payload)

        this.dialogInfo = true;
        this.infoTitle = "Documentos";
        this.enrollmentInfoHeaders = this.documentsHeaders;
        this.documentsInfo = true;
    },
    async showEnrollmentPayments(enrollment_id, student_id) {
      const payload = {
          enrollment_id: enrollment_id,
          student_id: student_id
        }
      await this.$store.dispatch('fetchEnrollmentStatus', payload)

      this.documentsInfo = false;
      this.dialogInfo = true;
      this.infoTitle = "Pagos";
    },
    showFile(fileToShow, open_dialog = true) {

      if (fileToShow.codigo_homini) {
        if(fileToShow.document){
          if (fileToShow.document.signs_number == 2) {
            this.path_file = `data:application/pdf;base64,${fileToShow.documento_homini_2}`
            if (((this.student && this.student.father_lives && this.student.father_lives.toLowerCase() == 'no') || (this.student && this.student.mother_lives && this.student.mother_lives.toLowerCase() == 'no'))) {
              this.path_file = `data:application/pdf;base64,${fileToShow.documento_homini}`
            }
            if(open_dialog) {
              this.dialog = true
            }
            return
          }
        }
        this.path_file = `data:application/pdf;base64,${fileToShow.documento_homini}`
        if(open_dialog) {
          this.dialog = true
        }
        return
      }

      if (fileToShow[`360_document_status`]) {
        const id_doc = fileToShow['360_document_id']
        const url = `${this.url_base}ViewDocument?id=${id_doc}`
        this.path_file = url
        if(open_dialog) {
          this.dialog = true
        }
        return
      }
      this.path_file = fileToShow.path_file
      if(open_dialog) {
        this.dialog = true
      }
    },
    formatNumber(number) {
      if(typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    validateIfErrorExist(field) {
      if(field) {
        const result = field.search("SIESA_ERROR")
        if(result === -1){
          return true;
        }else{
          return false
        }
      } else {
        return ''
      }
    },
    showError(error) {
      this.error_siesa = error
      this.dialogError = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/reports.vue